import { Switch as AntdSwitch } from 'antd'
import hoistNonReactStatics from 'hoist-non-react-statics'
import { Switch as BaseSwitch } from './Switch'

export type { SwitchProps } from './Switch'

export const Switch = hoistNonReactStatics(BaseSwitch, AntdSwitch)
